import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { Notyf } from 'notyf';
import 'notyf/notyf.min.css';
const notyf = new Notyf({ duration: 7000, position: { x: 'right', y: 'bottom' } });


export const fetchServiceProviders = createAsyncThunk('serviceProviders/fetchServiceProviders', async (token) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}/api/auth/services`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
        });

        if (!response.ok) {
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        return result.providers;
    } catch (error) {
        console.error('Error fetching services:', error);
    }
});

//todo: ADD ACTION:
export const addServiceProvider= createAsyncThunk('serviceProviders/addServiceProvider', async ({token,formData}) => {
    try {
        const response=await fetch(`${process.env.REACT_APP_API_URL}/api/auth/add_service`, {
            method: 'POST',
                headers: {
                // 'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
                },
                body:formData,
        });

        if (!response.ok) {
            notyf.error('Failed to add service.');
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        return notyf.success(result.message);
    } catch (error) {
        console.error('Error fetching actions:', error);
    }
});


//todo: DELETE ACTION:
export const deleteServiceProvider= createAsyncThunk('serviceProviders/deleteServiceProvider', async ({token,selectedRow}) => {
    
    try {
        const response=await fetch(`${process.env.REACT_APP_API_URL}/api/auth/delete_service`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body:JSON.stringify({id:selectedRow?.id})
        });

        if (!response.ok) {
            notyf.error('Failed to delete provider.');
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        return notyf.success(result.message);
    } catch (error) {
        console.error('Error deleting actions:', error);
    }
});

//todo: UPDATE ACTION:
export const updateServiceProvider= createAsyncThunk('serviceProviders/updateServiceProvider', async ({token,selectedRow}) => {
    
    try {
        const response=await fetch(`${process.env.REACT_APP_API_URL}/api/auth/update_service`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`,
            },
            body:JSON.stringify(selectedRow)
        });

        if (!response.ok) {
            notyf.error('Failed to update action.');
            throw new Error('Network response was not ok');
        }

        const result = await response.json();
        return notyf.success(result.message);
    } catch (error) {
        console.error('Error updating action:', error);
    }
});



//!fetch actions:
const serviceProvidersSlice = createSlice({
    name: 'serviceProviders',
    initialState: {
        providers: null,
        status: 'idle',
        statusAdd: 'idle',
        error: null,   
        errorAdd: null,  
        statusDelete: 'idle',
        errorDelete: null,  
        statusUpdate: 'idle',
        errorUpdate: null,  

    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchServiceProviders.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchServiceProviders.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.providers = action.payload;
            })
            .addCase(fetchServiceProviders.rejected, (state, action) => {
                state.status = 'failed';
                state.errorAdd = action.error.message;
            })
            .addCase(addServiceProvider.pending, (state) => {
                state.statusAdd = 'loading';
            })
            .addCase(addServiceProvider.fulfilled, (state, action) => {
                state.statusAdd = 'succeeded';
            })
            .addCase(addServiceProvider.rejected, (state, action) => {
                state.statusAdd = 'failed';
                state.errorAdd = action.error.message;
            })
            .addCase(deleteServiceProvider.pending, (state) => {
                state.statusDelete = 'loading';
            })
            .addCase(deleteServiceProvider.fulfilled, (state, action) => {
                state.statusDelete = 'succeeded';
            })
            .addCase(deleteServiceProvider.rejected, (state, action) => {
                state.statusDelete = 'failed';
                state.errorDelete = action.error.message;
            })
            .addCase(updateServiceProvider.pending, (state) => {
                state.statusUpdate = 'loading';
            })
            .addCase(updateServiceProvider.fulfilled, (state, action) => {
                state.statusUpdate = 'succeeded';
            })
            .addCase(updateServiceProvider.rejected, (state, action) => {
                state.statusUpdate = 'failed';
                state.errorUpdate = action.error.message;
            })
    },
});
export const serviceProvidersReducer= serviceProvidersSlice.reducer;
